import React from 'react'
import { Badge, Box, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { blue, green, yellow, common, orange } from '@mui/material/colors'
import WarningRoundedIcon from '@mui/icons-material/WarningRounded'
import T from 'T'

const LEGEND_ITEMS = [
  { label: T.RECURRING, color: blue[100] },
  { label: T.ON_REQUEST, color: yellow[100] },
  { label: T.MIXED, color: green[100] },
]

const SampleCircle = styled(Box)(({ bgcolor }) => ({
  width: 36,
  height: 36,
  borderRadius: '50%',
  backgroundColor: bgcolor,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '0.75rem',
  fontWeight: 400,
  color: common.black,
  position: 'relative',
}))

const SampleBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: 4,
    top: 8,
    minWidth: 14,
    height: 14,
    fontSize: '0.5625rem',
    fontWeight: 400,
    padding: '0 3px',
    backgroundColor: theme.palette.primary.main,
    color: common.white,
    border: `1.5px solid white`,
  },
}))

const RoutingCalendarLegend = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        mr: 'auto',
        gap: 1.5,
        px: 1.5,
        mt: 2,
        pt: 2,
        pb: 1,
        minWidth: 100,
      }}
    >
      <Typography variant="caption" sx={{ fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.5 }}>
        {T.LEGEND}:
      </Typography>

      {LEGEND_ITEMS.map(item => (
        <Box key={item.label} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
          <SampleBadge overlap="circular" badgeContent={1} sx={{ width: 30, height: 30 }}>
            <SampleCircle bgcolor={item.color} sx={{ width: 30, height: 30 }}>
              <Typography variant="caption" sx={{ fontWeight: 600, fontSize: '0.625rem', textTransform: 'uppercase' }}>
                15
              </Typography>
            </SampleCircle>
          </SampleBadge>
          <Typography variant="caption" sx={{ fontWeight: 600, fontSize: '0.625rem', textTransform: 'uppercase' }}>
            {item.label}
          </Typography>
        </Box>
      ))}

      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
        <WarningRoundedIcon sx={{ fontSize: 28, color: orange[600] }} />
        <Typography variant="caption" sx={{ fontWeight: 600, fontSize: '0.625rem', textTransform: 'uppercase', textAlign: 'center' }}>
          {T.UNASSIGNED}
          <br />
          {T.STOP_TITLE}
        </Typography>
      </Box>
    </Box>
  )
}

export default RoutingCalendarLegend
